import { config } from '../../../config';

const oldBaseSIP2Url = 'https://sip2.prd.bild.leancms.de/sip2/v2/i';
const baseSIP2UrL = 'https://editorial.one/sip2/v2/i';
const baseBildUrl = 'https://images.bild.de';

export const mapTeaserImageUrl = (rawTeaserImageUrl: string, tenant?: string) => {
    // transform old sip url to new one
    if (rawTeaserImageUrl) {
        rawTeaserImageUrl = rawTeaserImageUrl.replace(oldBaseSIP2Url, baseSIP2UrL);
    }
    // transform bild sip url to images url (this way they are also working outside VPN)
    if (tenant === 'bild' && config.USE_BILD_IMAGE_SERVER && rawTeaserImageUrl) {
        return rawTeaserImageUrl.replace(`${baseSIP2UrL}/bild`, baseBildUrl);
    }
    return rawTeaserImageUrl;
};
